import {LeftOutlined} from '@ant-design/icons';
import {Badge} from '@ds/components';
import {cn} from '@ds/helpers';
import {useNavigate} from 'react-router-dom';

type ActionRowProps = {
  title: string;
  navigationUrl: string;
  icon: React.ReactNode;
  badge?: string | number;
  className?: string;
};

const ActionRow: React.FC<ActionRowProps> = ({title, navigationUrl, icon, badge, className}) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className={cn(
        'flex w-full items-center justify-between gap-3 rounded-[10px] border border-gray-03 bg-white p-5 text-start',
        className
      )}
      onClick={() => navigate(navigationUrl)}
    >
      <span className="flex items-center gap-3.75 text-body-sm-emphasis text-neutral-fg">
        {icon}
        {title}
      </span>
      <span className="flex items-center gap-1.25">
        {badge !== undefined && badge !== 0 && (
          <Badge variant="count" color="error" size="md" count={badge} />
        )}
        <LeftOutlined className="text-gray-06" aria-hidden />
      </span>
    </button>
  );
};

export default ActionRow;
